import React, { useEffect, useState } from "react";
import api from "../lib/api";

export default function OspiteAvatar({ ospite, size = 40 }) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let obj = null;
    if (ospite.foto_path) {
      api.get(`/ospiti/${ospite.id}/foto`, { responseType: "blob" })
        .then((r) => { obj = URL.createObjectURL(r.data); setUrl(obj); })
        .catch(() => setUrl(null));
    } else setUrl(null);
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [ospite.id, ospite.foto_path]);

  const initials = `${ospite.nome?.[0] || ""}${ospite.cognome?.[0] || ""}`;
  const s = { height: size, width: size };
  return url
    ? <img src={url} alt={initials} style={s} className="rounded-xl object-cover border shrink-0" data-testid={`avatar-${ospite.id}`} />
    : <div style={{ ...s, background: "var(--gr-primary)" }} className="rounded-xl grid place-items-center text-white font-bold shrink-0" data-testid={`avatar-${ospite.id}`}>
        <span style={{ fontSize: size * 0.36 }}>{initials}</span>
      </div>;
}
